export default __webpack_public_path__ + "static/media/59.cd5fc1b7.png";